// extracted by mini-css-extract-plugin
export default {"inputAreaContainer":"InputArea_inputAreaContainer__QfWAw","itemContainer":"InputArea_itemContainer__k539r","addButton":"InputArea_addButton__4V9M4"};